import type { Theme } from '../createTheme';

export function createTooltipStyles() {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme }: { theme: Theme }) => {
          return {
            backgroundColor: theme.palette.secondary.darker,
            fontSize: theme.ui.tooltip.typography.fontSize,
            fontWeight: theme.ui.tooltip.typography.fontWeight,
            lineHeight: theme.ui.tooltip.typography.lineHeight,
          };
        },
        arrow: ({ theme }: { theme: Theme }) => {
          return {
            color: theme.palette.secondary.darker,
          };
        },
      },
    },
  };
}
